import classNames from 'classnames';
import type { ReactNode } from 'react';
import { CheckPicker, Icon } from 'rsuite';
import type { ItemDataType } from 'rsuite/lib/@types/common';
import type { ProdutoDetalhado } from '../../../hooks/useProdutosCampanha';
import styles from '../OfferCreationForm.module.scss';

interface ProductSearchSectionProps {
  productsFound: ProdutoDetalhado[];
  selectedProductIds: (string | number)[];
  loading: boolean;
  disabled?: boolean;
  onChangeProduct: (value: (string | number)[] | null) => void;
  onSearch: (value: string) => void;
}

export const ProductSearchSection = ({
  productsFound,
  selectedProductIds,
  loading,
  disabled = false,
  onChangeProduct,
  onSearch,
}: ProductSearchSectionProps) => (
  <section className={`${styles.section} ${styles.search}`}>
    <p className={styles.subtitle}>Selecione um ou mais produtos para criar uma oferta</p>

    <CheckPicker
      className={classNames(styles['picker-wrapper'])}
      placeholder="Busque pelo produto desejado"
      data={productsFound}
      labelKey="description"
      valueKey="product_id"
      value={selectedProductIds}
      onChange={onChangeProduct}
      disabled={disabled}
      loading={loading}
      onOpen={() => {
        if (disabled) return;
        setTimeout(() => {
          const searchInput = document.querySelector('.rs-picker-search-bar-input') as HTMLInputElement;
          searchInput?.focus();
        }, 10);
      }}
      renderMenuItem={(_label: ReactNode, item: ItemDataType) => {
        if (!('product_id' in item) || !('description' in item)) {
          return null;
        }

        const product = item as { product_id: string | number; description: string };
        return (
          <div key={product.product_id}>
            {product.product_id} - {product.description}
          </div>
        );
      }}
      renderMenu={menu => {
        if (loading) {
          return (
            <p style={{ padding: 4, color: '#999', textAlign: 'center' }}>
              <Icon icon="spinner" spin /> Carregando...
            </p>
          );
        }
        return menu;
      }}
      style={{ width: '100%' }}
      onSearch={value => {
        if (!disabled) onSearch(value);
      }}
      cleanable={false}
      renderValue={(value, selectedItems: any[]) => {
        const MAX_VISIBLE_ITEMS = 2;
        const totalItems = selectedItems.length;
        if (totalItems <= MAX_VISIBLE_ITEMS) {
          return value.join(', ');
        }
        const visibleItemsLabel = selectedItems
          .slice(0, MAX_VISIBLE_ITEMS)
          .map(item => item.product_id)
          .join(', ');

        const remainingCount = totalItems - MAX_VISIBLE_ITEMS;
        const suffix = remainingCount > 1 ? 'produtos' : 'produto';

        return `${visibleItemsLabel} e mais ${remainingCount} ${suffix}`;
      }}
    />
  </section>
);

ProductSearchSection.displayName = 'ProductSearchSection';
